// import PageLandingDefault from 'components/pages/landing/page-landing-default';

import LayoutSetPublicProfessional from 'components/ui/layout-set/public/layout-set-public-professional';
import PageProfessionalLogin from 'components/pages/professional/public/login/page-professional-login';

// export default [
//   {
//     path: '/',
//     name: 'landing',
//     component: PageLandingDefault,
//   },
// ];

export default [
  {
    path: '/',
    component: LayoutSetPublicProfessional,
    children: [
      {
        path: '',
        name: 'landing-login',
        component: PageProfessionalLogin,
        props: route => ({
          redirect: route.query.redirect,
        }),
        meta: {
          auth: false,
          notify: false,
        },
      },
      {
        path: 'login',
        redirect: { name: 'landing-login' },
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/landing/index.js